module.exports = __webpack_public_path__ + "img/canvas_btm.f57414c7.png";